/*
    🔥 ESTILOS DE TABLA — 16 variantes

    Noveno eje. Igual que los alerts o los headers: un registro con
    variantes, y la tabla lee cuál está activa.

    ⚠️ QUÉ CAMBIA Y QUÉ NO

    Cambia cómo se SEPARAN las filas, cuánto pesa la cabecera y cómo
    se comporta el contenedor. NO cambia el comportamiento: orden,
    búsqueda, selección y exportación funcionan igual en las dieciséis.

    ⚠️ LA ELECCIÓN NO ES DE GUSTO

    En una tabla de tres columnas, las líneas divisorias sobran y
    ensucian. En una de doce, sin líneas no se sigue la fila con la
    vista. Con datos numéricos, la grilla completa ayuda a comparar
    columna contra columna. La variante correcta depende de la
    densidad de datos.

    rows    : line | zebra | zebra_col | card | none | grid | dashed | bordered
    header  : solid | soft | line | none | accent | dark | sticky_accent
*/

export const TABLE_TEMPLATES = [

    {
        id: 'default', label: '1. Clásica',
        rows: 'line', header: 'soft', hasBorder: true, hasHover: true,
        description: 'Línea entre filas y cabecera tenue. El equilibrio para la mayoría.',
    },

    {
        id: 'zebra', label: '2. Cebra',
        rows: 'zebra', header: 'solid', hasBorder: true, hasHover: true,
        description: 'Filas alternadas. Ayuda a seguir la línea en tablas anchas.',
    },

    {
        id: 'zebra_col', label: '3. Cebra vertical',
        rows: 'zebra_col', header: 'solid', hasBorder: true, hasHover: true,
        description: 'Columnas alternadas. Para comparar valores hacia abajo.',
    },

    {
        id: 'grid', label: '4. Grilla',
        rows: 'grid', header: 'solid', hasBorder: true, hasHover: true,
        description: 'Líneas en filas Y columnas. Para datos numéricos densos.',
    },

    {
        id: 'minimal', label: '5. Minimal',
        rows: 'none', header: 'line', hasBorder: false, hasHover: true,
        description: 'Sin bordes ni fondos. Para tablas de pocas columnas.',
    },

    {
        id: 'cards', label: '6. Tarjetas',
        rows: 'card', header: 'none', hasBorder: false, hasHover: true,
        description: 'Cada fila es una tarjeta separada. Bien en listados con imagen.',
    },

    {
        id: 'cards_soft', label: '7. Tarjetas suaves',
        rows: 'card_soft', header: 'none', hasBorder: false, hasHover: true,
        description: 'Tarjetas sin borde, separadas por fondo. Más liviano.',
    },

    {
        id: 'compact', label: '8. Compacta',
        rows: 'line', header: 'soft', hasBorder: true, hasHover: true, density: 'sm',
        description: 'Filas al mínimo. Para ver muchos registros de un vistazo.',
    },

    {
        id: 'comfortable', label: '9. Cómoda',
        rows: 'line', header: 'soft', hasBorder: true, hasHover: true, density: 'lg',
        description: 'Más aire entre filas. Para listados cortos con contenido rico.',
    },

    {
        id: 'elevated', label: '10. Elevada',
        rows: 'line', header: 'solid', hasBorder: true, hasHover: true, hasShadow: true,
        description: 'Con sombra y cabecera marcada. Destaca sobre el fondo.',
    },

    {
        id: 'accent_header', label: '11. Cabecera de marca',
        rows: 'zebra', header: 'accent', hasBorder: true, hasHover: true,
        description: 'Cabecera con el color de marca. Para paneles de una sola tabla.',
    },

    {
        id: 'dark_header', label: '12. Cabecera oscura',
        rows: 'line', header: 'dark', hasBorder: true, hasHover: true,
        description: 'Cabecera de alto contraste. Separa bien de un fondo claro.',
    },

    {
        id: 'dashed', label: '13. Punteada',
        rows: 'dashed', header: 'line', hasBorder: true, hasHover: true,
        description: 'Separación punteada. Suaviza tablas con muchas filas.',
    },

    {
        id: 'bordered', label: '14. Enmarcada',
        rows: 'bordered', header: 'solid', hasBorder: true, hasHover: true,
        description: 'Cada fila con su propio marco. Bien con acciones por fila.',
    },

    {
        id: 'accent_left', label: '15. Barra lateral',
        rows: 'accent_left', header: 'soft', hasBorder: true, hasHover: true,
        description: 'Una barra de color a la izquierda al pasar el mouse.',
    },

    {
        id: 'report', label: '16. Reporte',
        rows: 'report', header: 'sticky_accent', hasBorder: true, hasHover: false,
        density: 'sm',
        description: 'Estilo planilla: sin hover, líneas finas, cabecera fija de marca.',
    },

];

export const TABLE_TEMPLATE_IDS = TABLE_TEMPLATES.map((item) => item.id);

const FALLBACK_TEMPLATE = TABLE_TEMPLATES[0];

export const onResolveTableTemplate = (id) => (
    TABLE_TEMPLATES.find((item) => item.id === id) ?? FALLBACK_TEMPLATE
);
